/**
 * Shared types for components
 */

/**
 * Base props shared by all page components
 * componentPosition: 0-based index of the component in the page's component array
 */
export interface BaseComponentProps {
    componentPosition?: number;
    isNested?: boolean;
    parentPosition?: number;
}

// A navigation entry as the mappers produce it (id/slug ready). Defined in the
// entities layer; re-exported here for the UI components that consume it, so the
// dependency points inward (app → entities).
export type { MenuItem } from '@/entities/models/layout/menu-item/menu-item.schema';

// MediaPosition const object for convenient usage (e.g., MediaPosition.TOP_LEFT)
// Type is inferred from the const object values
export const MediaPosition = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
} as const;

export type MediaPosition = (typeof MediaPosition)[keyof typeof MediaPosition];
